import { TypeEvent, TypeEventResult } from "@lexriver/type-event"
const filename = 'GlobalRightSidebar'

export module GlobalRightSidebar{
    let isVisible:boolean = false
    export function checkIfVisible(){
        return isVisible
    }
    //export const eventOnChange = new TypeEvent<(visible:boolean, x?:number)=>TypeEventResult>()
    export const eventOnHide = new TypeEvent()
    export const eventOnShow = new TypeEvent()
    export const eventOnMove = new TypeEvent<(x:number)=>TypeEventResult>()

    // eventOnHide.subscribe(() => {
    //     isVisible = false
    // })
    // eventOnShow.subscribe(() => {
    //     isVisible = true
    // })

    export async function showAsync(){
        //console.log(filename, 'show')
        await eventOnShow.triggerAsync()
        isVisible = true
    }

    export async function hideAsync(){
        //console.log(filename, 'hide')
        await eventOnHide.triggerAsync()
        isVisible = false
    }

    export async function moveAsync(x:number){
        //console.log(filename, 'move', x)
        await eventOnMove.triggerAsync(x)
    }


}